<div class="profile-page">
    <!-- HERO -->
    <section class="profile-hero">
        <div class="profile-hero-container">
            <div class="profile-breadcrumb">Inicio / Mi cuenta</div>
            <h1>Mi <span class="nina-brand-italic">cuenta</span></h1>
            <p>Hola. Qué gusto verte de nuevo.</p>
        </div>
    </section>
    <!-- CONTENIDO -->
    <div class="profile-container">
        <!-- PERFIL -->
        <section class="profile-card">
            <div class="profile-card-header">
                <div class="profile-card-title">
                    <span class="profile-eyebrow">MI CUENTA</span>
                    <h1>Mi perfil</h1>
                    <p>Consulta los datos de tu cuenta.</p>
                </div>

                <!-- <button class="profile-edit-button" type="button" (click)="openDialogEditProfile()"
                    [disabled]="dataProfile == null">
                    <mat-icon>edit</mat-icon>
                    Editar perfil
                </button> -->
            </div>
            <div class="profile-data" *ngIf="dataProfile != null">
                <!-- NOMBRE -->
                <div class="profile-data-item profile-data-item-large">
                    <span class="profile-label"> NOMBRE COMPLETO </span>
                    <span class="profile-value">
                        {{ dataProfile.names || "—" }}
                        {{ dataProfile.last_name || "" }}
                        {{ dataProfile.last_name2 || "" }}
                    </span>
                </div>
                <!-- CORREO -->
                <div class="profile-data-item">
                    <span class="profile-label"> CORREO ELECTRÓNICO </span>
                    <span class="profile-value">
                        {{ dataProfile.email || "No se encontró este dato" }}
                    </span>
                </div>
                <!-- TELÉFONO -->
                <div class="profile-data-item">
                    <span class="profile-label"> TELÉFONO </span>
                    <span class="profile-value">
                        {{ dataProfile.phone || "—" }}
                    </span>
                </div>
                <!-- GÉNERO -->
                <div class="profile-data-item">
                    <span class="profile-label"> GÉNERO </span>
                    <span class="profile-value">
                        {{
                        dataProfile.gender === "F"
                        ? "Femenino"
                        : dataProfile.gender === "M"
                        ? "Masculino"
                        : dataProfile.gender === "O"
                        ? "Otro"
                        : "—"
                        }}
                    </span>
                </div>
                <!-- FECHA DE NACIMIENTO -->
                <div class="profile-data-item">
                    <span class="profile-label"> FECHA DE NACIMIENTO </span>
                    <span class="profile-value">
                        {{ formatBirthdate(dataProfile.birthdate) }}
                    </span>
                </div>
                <!-- CÓDIGO POSTAL -->
                <div class="profile-data-item">
                    <span class="profile-label"> CÓDIGO POSTAL </span>
                    <span class="profile-value">
                        {{ dataProfile.main_zip_code || "—" }}
                    </span>
                </div>
                <!-- COLONIA -->
                <div class="profile-data-item">
                    <span class="profile-label"> COLONIA </span>
                    <span class="profile-value">
                        {{ dataProfile.locality?.name || "—" }}
                    </span>
                </div>
                <!-- MUNICIPIO -->
                <div class="profile-data-item">
                    <span class="profile-label"> MUNICIPIO </span>
                    <span class="profile-value">
                        {{ dataProfile.municipality || "—" }}
                    </span>
                </div>
                <!-- ESTADO -->
                <div class="profile-data-item">
                    <span class="profile-label"> ESTADO </span>
                    <span class="profile-value">
                        {{ dataProfile.state || "—" }}
                    </span>
                </div>
            </div>
            <div class="profile-empty" *ngIf="dataProfile == null">
                No se encontró información de tu perfil.
            </div>
            <div class="profile-actions">
                <button class="profile-password-button" mat-raised-button type="button"
                    (click)="openDialogChangePassword()">
                    Cambiar contraseña
                </button>
                <button class="profile-logout-button" mat-stroked-button type="button" (click)="logout()">
                    Cerrar sesión
                </button>
                <button class="profile-delete-button" type="button" (click)="deleteAccount()">
                    Eliminar cuenta
                </button>
            </div>
        </section>
        <!-- FAMILIARES -->
        <app-familiars></app-familiars>
        <!-- DIRECCIONES -->
        <app-directions></app-directions>
    </div>
</div>